import React from 'react'
import PropTypes from 'prop-types'
import { SubmissionError } from 'redux-form'
import { isApiError } from 'services/rest/helpers'
import { rest } from 'services'
import { HOME } from 'constant'
import { MAX_LENGTH, CODE_SAME_PASSWORD } from './constants'
import { rules } from './validatorConfig'
import enhance from './enhancer'
import form from './form'
import ResetPasswordWrapper from './ResetPasswordWrapper'

/* eslint-disable react/sort-comp */
class ResetPassword extends React.Component {
  constructor() {
    super()

    this.state = {
      samePassError: {
        code: '',
        description: ''
      }
    }
    // will be passed to Input component
    this.handlers = {
      onChange: () =>
        this.props.change(form.hiddenField.name, this.props.values[form.password.name])
    }
  }

  setSamePassError = ({ code, description }) => {
    this.setState(state => ({
      ...state,
      samePassError: {
        code,
        description
      }
    }))
  }

  handleTokenCancellation = () => {
    const { queryParams } = this.props
    rest.api
      .cancelResetPassword({
        token: queryParams.token
      })

    this.props.redirectTo(HOME)
  }

  handleApiFailure = err => {
    if (err.status.code === CODE_SAME_PASSWORD) {
      this.setSamePassError({ code: err.status.code, description: err.status.description })
    } else {
      this.setSamePassError({ code: '', description: '' })
    }

    throw isApiError(err) ? new SubmissionError({ _error: err.status.description }) : err
  }

  redirectToAccount = () => {
    this.props.redirectTo(this.props.myAccountLink.path)
  }

  submit = () => {
    const { queryParams, values } = this.props
    rest.api
      .resetPassword({
        ...values,
        token: queryParams.token,
        tokenId: queryParams.tokenId
      })
      .then(this.redirectToAccount)
      .catch(this.handleApiFailure)
  }
  render() {
    const {
      status,
      isPasswordFieldActive,
      forgotPasswordLink: {
        path = ''
      } = {},
      // redux-form properties
      anyTouched,
      values,
      pristine,
      error = '',
      submitting,
      handleSubmit
    } = this.props

    const { samePassError } = this.state

    return (
      <ResetPasswordWrapper
        samePassError={ samePassError }
        anyTouched={ anyTouched }
        form={ form }
        error={ error }
        rules={ rules }
        values={ values }
        status={ status }
        path={ path }
        maxLength={ MAX_LENGTH }
        pristine={ pristine }
        isPasswordFieldActive={ isPasswordFieldActive }
        isSubmitting={ submitting }
        handleSubmit={ handleSubmit }
        handleCustomSubmit={ this.submit }
        handlers={ this.handlers }
        handleTokenCancellation={ this.handleTokenCancellation } />
    )
  }
}

/* eslint-disable react/no-unused-prop-types */
ResetPassword.propTypes = {
  anyTouched: PropTypes.bool,
  change: PropTypes.func,
  error: PropTypes.node,
  forgotPasswordLink: PropTypes.shape({
    path: PropTypes.string
  }),
  handleSubmit: PropTypes.func,
  isPasswordFieldActive: PropTypes.bool,
  myAccountLink: PropTypes.shape({
    path: PropTypes.string
  }),
  pristine: PropTypes.bool,
  profileId: PropTypes.string,
  queryParams: PropTypes.shape(),
  redirectTo: PropTypes.func,
  status: PropTypes.shape({
    code: PropTypes.string,
    description: PropTypes.string
  }),
  submitting: PropTypes.bool,
  tokenId: PropTypes.string,
  values: PropTypes.shape()
}

const EnhancedResetPassword = enhance(ResetPassword)

EnhancedResetPassword.type = 'ResetForgottenPassword'

export default EnhancedResetPassword
